import { differenceInDays } from 'date-fns';
import { IS_PROD } from 'settings';

class Hotjar {
  public emitResearchEventAfterWatchLesson(matriculationDate: string, userCod: number): void {

    if (differenceInDays(new Date(), new Date(matriculationDate)) < 15) return;

    this.emitResearchEvent();
  }

  private emitEvent(actionName: string): void {
    if(IS_PROD){
      hj('event', actionName);
    }
  }

  private emitResearchEvent(): void {
    const time = JSON.parse(localStorage.getItem('CSAT_research_learner'));
    const showResearch = !time || (typeof time === 'number' && new Date() > new Date(time));

    if (showResearch == false) return;

    this.emitEvent('CSAT_research_learner');

    const showResearchAfter60days = new Date().getTime() + 1000 * 60 * 60 * 24 * 60;
    localStorage.setItem('CSAT_research_learner', JSON.stringify(showResearchAfter60days));
  }
}

const hotjar = new Hotjar();
export default hotjar;
